import * as React from 'react';
import { SVGType } from '../types';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IPrivateModeProtectionCircleIconProps extends SVGType {}

export const PrivateModeProtectionCircleIcon: React.FunctionComponent<IPrivateModeProtectionCircleIconProps> = ({
  stroke = '#6B7280',
  size = 34,
  ...rest
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 34 32" {...rest}>
      <g stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" clipPath="url(#clip0_2556_29332)">
        <path d="M24.38 14.476H9.144M12.484 23.238a2.476 2.476 0 100-4.952 2.476 2.476 0 000 4.952zM20.919 23.238a2.476 2.476 0 100-4.952 2.476 2.476 0 000 4.952zM18.442 20.42H14.96M22.095 14.476l-.888-5.33a1.828 1.828 0 00-1.805-1.527H14.12M14.12 7.619a1.828 1.828 0 00-1.803 1.528M12.317 9.146l-.888 5.33"></path>
        <path d="M16.762 30.476c7.995 0 14.476-6.481 14.476-14.476 0-7.995-6.481-14.476-14.476-14.476C8.767 1.524 2.286 8.005 2.286 16c0 7.995 6.481 14.476 14.476 14.476z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2556_29332">
          <path fill="#fff" d="M0 0H33.524V32H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default PrivateModeProtectionCircleIcon;
